(function () {

    'use strict';

    angular.module('iplusjs.list.simple', [
        'iplusjs.utils.scrollToTop',
        'iplusjs.utils.focusFirst',
        'lodash'
    ])
        .component('iplusjsSimpleList', {
            bindings: {
                items: '<islItems',
                itemsSeperatorText: '@?islItemsSeperatorText',
                preferredItems: '<?islPreferredItems',
                preferredItemsSeperatorText: '@?islPreferredItemsSeperatorText',
                emptyText: '@?islEmptyText',
                onSelect: '&islOnSelect',
                isLoading: '<islIsLoading',
                options: '<islOptions'
            },
            templateUrl: 'common/list/simpleList.html',
            controller: SimpleListController,
            controllerAs: 'simpleListVm'
        });

    SimpleListController.$inject = [
        '$element',
        '$timeout',
        'lodash'
    ];
    function SimpleListController($element, $timeout, _) {
        var vm = this,
            keyCodes = {
                ENTER: 13
            };

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;
        vm.onClick = onClick;
        vm.onKeydown = onKeydown;
        vm.getAriaText = getAriaText;

        function activate() {
            vm.options = vm.options || {};
            vm.options.scrollToTop = _.isNil(vm.options.scrollToTop) ? true : vm.options.scrollToTop;

            vm.hasPreferredItems = !!(vm.preferredItems || []).length;
            vm.hasItems = vm.hasPreferredItems || !!(vm.items || []).length;
            vm.itemsSeperatorText = vm.itemsSeperatorText || 'ALLE';
            vm.preferredItemsSeperatorText = vm.preferredItemsSeperatorText || 'MEISTGEWÄHLTE';
            vm.emptyText = vm.emptyText || 'Keine Treffer gefunden';
        }

        function onInit() {
            activate();
        }

        function onChanges(changes) {
            activate();

            if (changes.items || changes.itemsSeperatorText) {
                if (vm.options.scrollToTop) {
                    vm.scrollToTop = false;
                }

                if (vm.options.focusFirst) {
                    vm.focusFirst = false;
                }

                $timeout(function () {
                    if (vm.options.scrollToTop) {
                        vm.scrollToTop = true;
                    }

                    if (vm.options.focusFirst) {
                        vm.focusFirst = true;
                    }
                });
            }
        }
        function onClick(item) {
            selectItem(item);
        }
        function onKeydown(event, item) {
            if (event && event.keyCode === keyCodes.ENTER) {
                event.preventDefault();

                selectItem(item);
            }
        }
        function selectItem(item) {
            vm.onSelect({
                item: item
            });
        }

        function getAriaText(item) {
            return _.join(_.compact([
                _.get(vm.options, 'ariaText'),
                item.display
            ]), ' ');
        }

    }
})();
